'use client'

import Transition from '@/components/Motion/Transition'
import Image from 'next/image'

interface NoResultsFoundProps {
  message?: string
  imageWidth?: number
  imageHeight?: number
  className?: string
}

const NoResultsFound: React.FC<NoResultsFoundProps> = ({
  message = 'No results match your search',
  imageWidth = 250,
  imageHeight = 250,
  className = 'mt-5', // Default margin top
}) => {
  return (
    <Transition>
      <div
        className={`flex w-full flex-col items-center justify-center text-gray-900 ${className}`}
      >
        <Image
          width={imageWidth}
          height={imageHeight}
          alt="No result"
          src="/images/dashboard/no-result.png"
        />
        <p className="mt-2 text-xl font-medium">{message}</p>
      </div>
    </Transition>
  )
}

export default NoResultsFound
